/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { GoogleMap, Marker } from "@react-google-maps/api";
import DoctorCards from "../../Component/DoctorCards";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const Doctor = () => {
  const [Position, setPosition] = useState([]);
  const [Center, setCenter] = useState({ lat: 0, lng: 0 });
  const data = useSelector((state) => state.AllDoctorApi);
  const location = useLocation();
  console.log(data, "data=====");
  // pagination code
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = data.slice(startIndex, endIndex);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  console.log(currentData, "currentData");

  // Function to handle previous page button click
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      handlePageChange(currentPage + 1);
    }
  };
  const searchdata = location.state;

  useEffect(() => {
    if (searchdata !== null) {
      setPosition(
        searchdata.map((e) => {
          return {
            lat: Number(e.latitude),
            lng: Number(e.longitude),
          };
        })
      );
    } else {
      setPosition(
        data.map((marker) => {
          return {
            lat: parseFloat(marker.lat),
            lng: parseFloat(marker.lng),
          };
        })
      );
    }
    //   setPosition(newMarkers);
    // });
  }, [data, searchdata]);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      setCenter({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });
      console.log(position, "data");
    });
  }, []);


  const rating = currentData.map((e) => e.averageRating);

  const elements = [];

  for (let i = 1; i <= rating; i++) {
    elements.push(<i class="icon_star voted"></i>);
  }

  return (
    <>
      <Header />
      <div id="page">
        <aside class="col-lg-12" id="sidebar">
          {Position.length > 0 ? (
            <div className="" style={{}}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={{ lat: Center.lat, lng: Center.lng }}
                zoom={1.5}
                options={{
                  zoomControl: true,
                  streetViewControl: false,
                  mapTypeControl: false,
                  fullscreenControl: false,
                }}
              >
                {data?.map((e, index) => {
                  return (
                    <Marker
                      key={index}
                      position={{
                        lat: Number(e.lat),
                        lng: Number(e.lng),
                      }}
                    />
                  );
                })}
                {/* <MarkerF
                      // key={index}
                        position={{
                          lat: Position[0]?.lat,
                          lng: Position[0]?.lng,
                        }}
                      /> */}
              </GoogleMap>
            </div>
          ) : null}
        </aside>

        <div class="container">
          {searchdata?.length == 0 ? (
            <div id="results" className="mb-5 bg-theme">
              <div class="container">
                <div class="row mt-5">
                  <div class="col-md-12 text-center ">
                    <h4>
                      <strong>No Results Found</strong>
                    </h4>
                  </div>
                </div>
                {/* <!-- /row --> */}
              </div>
              {/* <!-- /container --> */}
            </div>
          ) : (
            <div class="container">
              <div class="row mt-5">
                <div class="col-md-12 col-lg-3 text-start fw-bolder">
                  <h4>
                    <strong
                      style={{ borderRight: "4px solid #0d6efd" }}
                      className="pe-1"
                    >
                      Showings {searchdata !== null ? searchdata.length : null}{" "}
                      {searchdata === null ? data?.length : null} Results
                    </strong>
                  </h4>
                </div>
              </div>
              {/* <!-- /row --> */}
            </div>
          )}
          {/* <!-- /results --> */}

          <div class="row justify-content-center mt-3">
            {searchdata !== null ? (
              <>
                <div className="row">
                  {searchdata?.map((e) => (
                    <Link className="col-lg-4" to={"/details?id=" + e?.id}>
                      <DoctorCards
                        id={e?.id}
                        bio={e?.bio}
                        fname={e?.first_name}
                        lname={e?.last_name}
                        address={e?.address}
                        city={e?.city}
                        country={e?.country}
                        rating={e?.avg_review}
                        fee={e?.categories?.length > 0
                          ? Math.min(...e?.categories.map(category => parseInt(category.fee)))
                          : e?.categories?.map(category => Number(category.fee))}
                      />
                    </Link>
                  ))}
                </div>
              </>
            ) : null}

            {searchdata === null ? (
              <>
                <div className="row">
                  {currentData?.map((e) => (
                    <>
                      <Link className="col-lg-4" to={"/details?id=" + e?.id}>
                        <DoctorCards
                          id={e?.id}
                          bio={e?.bio}
                          fname={e?.first_name}
                          lname={e?.last_name}
                          address={e?.address}
                          city={e?.city}
                          country={e?.country}
                          rating={e?.avg_review}
                          fee={e?.categories?.length > 0
                            ? Math.min(...e?.categories.map(category => parseInt(category.fee)))
                            : e?.categories?.map(category => Number(category.fee))}
                        />

                      </Link>
                    </>
                  ))}
                </div>
              </>
            ) : null}

            {/* Render pagination controls */}
            <nav aria-label="Page navigation example">
              <ul class="pagination justify-content-center pagination-lg">
                <li class="page-item ">
                  <span
                    class="page-link"
                    href="#"
                    tabindex="-1"
                    disabled={currentPage === 1}
                    onClick={handlePreviousPage}
                  >
                    Previous
                  </span>
                </li>
                {Array.from({ length: totalPages }).map((_, index) => (
                  <li
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    className={
                      currentPage === index + 1
                        ? "active page-item"
                        : "page-item"
                    }
                  >
                    <span class="page-link">{index + 1}</span>
                  </li>
                ))}

                <li
                  class="page-item"
                  disabled={currentPage === totalPages}
                  onClick={handleNextPage}
                >
                  <span class="page-link" href="#">
                    Next
                  </span>
                </li>
              </ul>
            </nav>

            {/* <!-- /col --> */}

            {/* <!-- /aside --> */}
          </div>
          {/* <!-- /row --> */}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Doctor;
